import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../../authAxios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./ApproveReject.css";

export default function ApproveReject() {
  const { id, token } = useParams();
  const [isApproved, setIsApproved] = useState(false);
  const [visitDetails, setVisitDetails] = useState();
  const navigate = useNavigate();
  console.log(id);
  console.log(token);

  useEffect(() => {
    fetchVisitData();
  }, []);

  const fetchVisitData = () => {
    try {
      axios
        .get("/get-visitlog/" + id + "/" + token)
        .then((response) => {
          if (response.data.status) {
            setVisitDetails(response.data.data);
            console.log(response.data.data);
            return;
          }
        })
        .catch((error) => {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Error in getting visitor details",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    } catch (error) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Error in getting visitor details",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  function formatTimestamp(timestamp) {
    // Convert string to Date object
    var date = new Date(timestamp);

    // Array of month names
    var months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Get the month, day, year, hours, and minutes
    var month = months[date.getMonth()];
    var day = date.getDate();
    var year = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();

    // Convert hours to 12-hour format
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight (0 hours)

    // Format the time and date
    var formattedTime =
      hours + ":" + (minutes < 10 ? "0" : "") + minutes + " " + ampm;
    var formattedDate = day + " " + month + " " + year;

    // Return the formatted string
    return formattedTime + " - " + formattedDate;
  }

  const handleApproveClick = () => {
    try {
      axios
        .get("/approve/" + token)
        .then((response) => {
          if (response.data.status) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Approved Successfully",
              showConfirmButton: false,
              timer: 1500,
            });
            fetchVisitData();
          } else {
            Swal.fire({
              position: "center",
              icon: "error",
              title: "Error",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Error",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    } catch (error) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Error",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };
  const handleRejectClick = () => {
    try {
      axios
        .get("/reject/" + token)
        .then((response) => {
          if (response.data.status) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Reject Successfully",
              showConfirmButton: false,
              timer: 1500,
            });
            fetchVisitData();
          } else {
            Swal.fire({
              position: "center",
              icon: "error",
              title: "Error",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Error",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    } catch (error) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Error",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };
  const formatStatusColor = (status) => {
    if (status == "PENDING") {
      return "#184CCF";
    } else if (status == "APPROVED") {
      return "green";
    } else if (status == "REJECTED") {
      return "red";
    }
    return "black";
  };
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          margin: "10px 20px",
          flexDirection:'column'
        }}
      >
        <div>
          <div
            style={{
              backgroundColor: "#E2E6F0",
              border: "3px dashed grey",
              // width: "100%",
              // maxWidth: "300px",
              padding: "8px 16px",
              borderRadius: "5px",
            }}
          >
            <h4 style={{ fontWeight: "600" }}>Visitor:</h4>
            <div
              style={{ padding: "10px 0px", borderBottom: "2px dashed grey" }}
            >
              <h5 style={{ color: "grey", margin: "0px" }}>Request time:</h5>
              <h4>{formatTimestamp(visitDetails?.request_time)}</h4>
              <div style={{ display: "flex" }}>
                <h4>
                  Status:{" "}
                  <span
                    style={{
                      color: formatStatusColor(visitDetails?.visit_status),
                    }}
                  >
                    {visitDetails?.visit_status}
                  </span>
                </h4>
              </div>
              <img
                style={{ width: "100px", height: "100px" }}
                src={visitDetails?.visitor_image}
                alt=""
              />
              <div style={{ display: "flex" }}>
                <h4>
                  Name: <span>{visitDetails?.visitor_name}</span>
                </h4>
              </div>
              <div style={{ display: "flex" }}>
                <h4>
                  Mobile: <span>{visitDetails?.visitor_phone_no}</span>
                </h4>
              </div>
              <div style={{ display: "flex" }}>
                <h4>
                  Email: <span>{visitDetails?.visitor_email}</span>
                </h4>
              </div>
              <div style={{ display: "flex" }}>
                <h4>
                  Reason to Meet: <span>{visitDetails?.reason}</span>{" "}
                </h4>
              </div>
            </div>
            {visitDetails?.visit_status == "PENDING" && (
              <div style={{ padding: "15px 0px" }}>
                <button
                  onClick={() => {
                    handleApproveClick();
                  }}
                  style={{
                    background: "var(--primary-color)",
                    width: "100%",
                    color: "white",
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "5px",
                  }}
                >
                  Grant Access
                </button>
                <br />
                <button
                  onClick={() => {
                    handleRejectClick();
                  }}
                  style={{
                    background: "#ECD8D8",
                    width: "100%",
                    color: "#E30A0A",
                    padding: "8px 16px",
                    border: "1px solid #E30A0A",
                    borderRadius: "5px",
                    marginTop: "10px",
                  }}
                >
                  Reject Request
                </button>
              </div>
            )}
          </div>
          <div>
            <button
              onClick={() => {
                navigate(-1);
              }}
              style={{
                padding: "8px 16px",
                backgroundColor: "var(--primary-color)",
                width: "100%",
                color: "white",
                border: "5px",
                marginTop: "15px",
              }}
            >
              Back{" "}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
